import { render, staticRenderFns } from "./TariffModal.vue?vue&type=template&id=11442ffe"
import script from "./TariffModal.vue?vue&type=script&lang=js"
export * from "./TariffModal.vue?vue&type=script&lang=js"
import style0 from "./TariffModal.vue?vue&type=style&index=0&id=11442ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports